/* ******************************** Logged In Scope *****************************
 * Anything that you want to be alive while the user is logged in should be
 * provided here. That means any services, view models, or domain models that are
 * provided here will be alive while the user is logged in, and will be destroyed
 * when the user logs out.
 */

import { TypeService } from '../services/type/type-service';
import { MembersDomainModel } from '../domainModels/members-domain-model';
import { InternalUsersDomainModel } from '../domainModels/internal-users-domain-model.service';
import { PermissionDomainModel } from '../domainModels/permission-domain-model';
import { EmployersDomainModel } from '../domainModels/employers-domain-model';
import { SubmissionsDomainModel } from '../domainModels/submissions-domain-model';
import { ProfileViewModel } from '../views/profile/components/profile-view-model';
import { AllInternalUsersDataTableViewModel } from '../views/settings/components/internal-users/internal-users/all-interal-users-data-table/all-internal-users-data-table-view-model';
import { AlertsDomainModel } from '../domainModels/alerts-domain-model';
import { TransactionDomainModel } from '../domainModels/transaction-domain-model';
import { MemberSubmissionHistoryService } from '../views/profile/components/user-profiles/member-user-profile/services/member-submission-history.service';
import { ReleaseNotesDomainModel } from '../domainModels/release-notes-domain-model';
import { WebSocketService } from '../services/web-socket.service';
import { RemittanceDomainModel } from '../domainModels/remittance-domain-model';
import { NextRemittanceDatesService } from '../views/remittance/services/next-remittance-dates.service';
import { MpProfilePostSubmissionRefreshService } from '../views/profile/services/mp-profile-post-submission-refresh.service';
import { MemberOnboardingDetailsService } from '../services/member-onboarding-details.service';

export const domainModelsGloballyScopedToLoginContext = [
  MembersDomainModel,
  InternalUsersDomainModel,
  PermissionDomainModel,
  EmployersDomainModel,
  SubmissionsDomainModel,
  AlertsDomainModel,
  TransactionDomainModel,
  ReleaseNotesDomainModel,
  RemittanceDomainModel
];

export const viewModelsGloballyScopedToLoginContext = [AllInternalUsersDataTableViewModel, ProfileViewModel];

export const servicesGloballyScopedToLoginContext = [
  TypeService,
  MemberSubmissionHistoryService,
  WebSocketService,
  NextRemittanceDatesService,
  MpProfilePostSubmissionRefreshService,
  MemberOnboardingDetailsService
];
